export default __webpack_public_path__ + "static/media/raiffeisen_s1.3afce57d.png";